<script setup lang="ts">
import {type Message, Sender, type Source} from "@/types.js";
import {computed} from "vue";
//@ts-ignore
import {HollowDotsSpinner} from 'epic-spinners'
import VueMarkdown from "vue-markdown-render";

const props = defineProps<{
  message: Message,
  sourceOrder: string[],
  sources: Map<string, Source>
}>()

const senderText = computed(() => {
  switch (props.message.sender) {
    case Sender.User:
      return "Ihre Nachfrage"
    case Sender.AI:
      return "KI"
    case Sender.Error:
      return "Fehler";
  }
});

const messageText = computed(() => {
  let messageContent = props.message.text;
  messageContent = messageContent.replace(/\[uid:\s*([a-f0-9]{32})\]/g, '[$1]');
  messageContent = messageContent.replace(/(mit\sder\s)?uid\s*"?([a-f0-9]{32})"?/gi, '[$2]');
  let citations = [...messageContent.matchAll(/\[([a-f0-9]{32})\]/g)]


  for (const citation of citations.map(c => c[0])) {
    let index = props.sourceOrder.findIndex(s => citation.includes(s))
    if (index < 0) {
      console.warn('citation not found')
      continue;
    }
    let source = props.sources.get(props.sourceOrder[index] || '');
    if (!source) {
      console.warn('source not found')
      continue;
    }
    messageContent = messageContent.replace(citation, `[(${source.title})](${source.url_id})`);
  }
  return messageContent
});
</script>

<template>
  <b-card class="message-card" :header="senderText" :header-variant="message.sender === Sender.Error?'danger':undefined"
          :border-variant="message.sender === Sender.Error?'danger':undefined">
    <hollow-dots-spinner
        :dot-size="10"
        :dots-num="3"
        :animation-duration="1000"
        color="var(--bs-primary)"
        v-if="message.text === '' && message.sender === Sender.AI"
    />
    <div class="message-content">
      <vue-markdown :source="messageText"/>
    </div>
    <slot></slot>
  </b-card>
</template>
